module.exports = __webpack_public_path__ + "img/a1a5ef5.png";